<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';

const route = useRoute();
const { updateUISettings } = useUISettings();

watch(
  () => route.params.inboxId,
  inboxId => {
    if (inboxId) updateUISettings({ last_active_meta_agent_inbox_id: inboxId });
  },
  { immediate: true }
);
</script>

<template>
  <router-view />
</template>
